/**
 * 配置项
 */
export default class Config {
    /**
     * 是否为调试模式
     */
    public static readonly IS_DEBUG: boolean = false;
    public static readonly API_HOST: string = this.IS_DEBUG ? "http://DESKTOP-SETS4BB:5086/api/" : "https://ad.api.baohuiinfo.com/api/";
    /**
     * 资源文件HOST(本地资源)
     */
    public static ResourceFileHost: string = "";
    /**
     * 存储桶的资源地址
     */
    public static MinioResourceURL: string = "";

    /**
     * 使用的存储桶名称
     */
    public static MinioUseBucketName:string = "";
    

    private static readonly MQTTHost: string = this.IS_DEBUG ? "tv.baohui.com" : "api.mqtt.k68.co";
    private static readonly MQTTProtocol: "ws" | "wss" = this.IS_DEBUG ? "ws" : "wss";
    private static readonly MQTTPort: number = this.IS_DEBUG ? 8083 : 443;
    // private static readonly MQTTHeadName: string = this.IS_DEBUG ? "ad" : "ad";
    public static readonly MQTTReconnectPeriod: number = 3000; //重连时间
    public static readonly MQTTConnectTimeout: number = 4000; //连接超时时间

    /**
     * MQTT服务URL地址
     */
    public static readonly MQTTServerURL: string = `${this.MQTTProtocol}://${this.MQTTHost}:${Config.MQTTPort}/mqtt`;

    /**
     * 时间控制器配置
     */
    public static TimeControllerOptions: {
        /**
         * 毫秒运算时间单位 默认 1000
         */
        MillisecondTimeUnit: number,
        /**
         * 每秒的像素宽度 默认 100
         */
        SecondWidth: number,
        /**
         * 每列的像素宽度 默认 10
         */
        ColumnWidth: number
    } = {
            MillisecondTimeUnit: 1000,
            SecondWidth: 100, //每秒的像素宽度
            ColumnWidth: 10 //列的颗粒度
        };
    }